export default __webpack_public_path__ + "static/media/2.e343104b.webp";